<template>
  <div class="app-accordion-wrapper">
    <slot name="txtBefore"></slot>
    <ProcessAccordion
      v-for="(processConfig, processIdentifier) in processes"
      :key="processIdentifier"
      :process-identifier="processIdentifier"
      :process-config="processConfig"
      ref="inneraccordion"
    >
      <template v-for="slot in possibleChildSlotsFor('Process', getAppendix(processIdentifier))" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </ProcessAccordion>
    <slot name="txtAfter"></slot>
  </div>
</template>
<script>

import slotProxy from '@/mixins/slotProxy'
import ProcessAccordion from '@/components/process/generic/Accordion/fyve/ProcessAccordion.vue'
import extraData from '@/mixins/extraData'

let unsubscribe

export default {
  name: 'AccordionWrapper',
  components: { ProcessAccordion },
  data () {
    return {}
  },
  mixins: [
    slotProxy(),
    extraData()
  ],
  async mounted () {
    // subscribe for changes to fetch new messages
    const component = this // subscribe auf store mutation
    unsubscribe = await component.$store.subscribe(function (mutation, state) {
      if (mutation.type === 'addError') {
        const allErr = mutation.payload.path
        component.$refs.inneraccordion.forEach((comp) => {
          comp.closeWhenError(allErr)
        })
      }
    })
  },
  beforeDestroy () {
    if (unsubscribe) {
      unsubscribe()
    }
  },
  methods: {
    getAppendix: function (identifier) {
      return identifier.charAt(0).toUpperCase() + identifier.slice(1)
    }
  },
  computed: {
    processes: function () {
      return this.extraData || {}
    }
  }
}
</script>
